<template>
  <div>
    <div class="reserveBox" ref="reserve">
      <a-skeleton active :title="false" :paragraph="{rows: 4}" />
    </div>
    <!-- <table border="1" class="tableReserve" style="border-color: #D9D9D9;border-style: none;width: 100%;">
      <tr>
        <th class="theadReserve" style="width: 100px;text-align: left;padding: 15px 16px ;font-size: 16px;font-weight: 400;color: #666;background-color: #FAFAFA;">资产编号</th>
        <td class="tdReserve" style="padding: 15px 20px;text-align: left;font-size: 14px;font-weight: 400;color: #666;width: 170px;">200505001</td>
        <th class="theadReserve" style="width: 100px;text-align: left;padding: 15px 16px ;font-size: 16px;font-weight: 400;color: #666;background-color: #FAFAFA;">仪器名称</th>
        <td class="tdReserve" style="padding: 15px 20px;text-align: left;font-size: 14px;font-weight: 400;color: #666;width: 170px;width:311px">高分辨场发射扫描电子显微镜</td>
        <th class="theadReserve" style="width: 100px;text-align: left;padding: 15px 16px ;font-size: 16px;font-weight: 400;color: #666;background-color: #FAFAFA;">仪器名称</th>
        <td class="tdReserve" style="padding: 15px 20px;text-align: left;font-size: 14px;font-weight: 400;color: #666;width: 170px;width:311px">高分辨场发射扫描电子显微镜</td>
      </tr>
      <tr>
        <th class="theadReserve" style="width: 100px;text-align: left;padding: 15px 16px ;font-size: 16px;font-weight: 400;color: #666;background-color: #FAFAFA;">管理员</th>
        <td class="tdReserve" style="padding: 15px 20px;text-align: left;font-size: 14px;font-weight: 400;color: #666;width: 170px;">张莎莎</td>
        <th class="theadReserve" style="width: 100px;text-align: left;padding: 15px 16px ;font-size: 16px;font-weight: 400;color: #666;background-color: #FAFAFA;">联系方式</th>
        <td class="tdReserve" style="padding: 15px 20px;text-align: left;font-size: 14px;font-weight: 400;color: #666;width: 170px;">021-34208498-6502</td>
        <th class="theadReserve" style="width: 100px;text-align: left;padding: 15px 16px ;font-size: 16px;font-weight: 400;color: #666;background-color: #FAFAFA;">联系方式</th>
        <td class="tdReserve" style="padding: 15px 20px;text-align: left;font-size: 14px;font-weight: 400;color: #666;width: 170px;">021-34208498-6502</td>
      </tr>
      <tr>
        <th class="theadReserve" style="width: 100px;text-align: left;padding: 15px 16px ;font-size: 16px;font-weight: 400;color: #666;background-color: #FAFAFA;">预约提醒</th>
        <td colspan="5" class="tdReserve" style="padding: 15px 20px;text-align: left;font-size: 14px;font-weight: 400;color: #666;width: 170px;">
          <div style="font-size:16px;font-weight:500">Sirion每周一17:00开放实验</div>
          <div style="font-weight:500">
            注意：<br>
            （1）样品应无水无油，无磁性；<br>
            （2）样品高度小于15 mm，直径小于30 mm。<br>
            （3）测试时，请带好预约单，提前15分钟到实验室进行制样或镀膜等准备工作； <br>
            （4）可做SE和EDS，不可做BSE和EBSD；<br>
            （5）取消实验需提前24h联系老师，否则按预约时间扣费。
          </div> 
          <table border="1" class="tableReserveA" style="border-color: #D9D9D9;border-style: none;background-color: #FFF;margin-top: 15px;margin-bottom: 15px;">
            <tr>
              <th class="theadReserveA" style="width: 80px;padding: 10px 20px;text-align: left;font-size: 14px;font-weight: 500;color: #666;">序号</th>
              <th class="theadReserveA" style="width: 80px;padding: 10px 20px;text-align: left;font-size: 14px;font-weight: 500;color: #666;width:110px">检测项目</th>
              <th class="theadReserveA" style="width: 80px;padding: 10px 20px;text-align: left;font-size: 14px;font-weight: 500;color: #666;width:200px">校内</th>
              <th class="theadReserveA" style="width: 80px;padding: 10px 20px;text-align: left;font-size: 14px;font-weight: 500;color: #666;width:200px">校外</th>
              <th class="theadReserveA" style="width: 80px;padding: 10px 20px;text-align: left;font-size: 14px;font-weight: 500;color: #666;width:200px">CMA</th>
              <th class="theadReserveA" style="width: 80px;padding: 10px 20px;text-align: left;font-size: 14px;font-weight: 500;color: #666;width:166px">备注</th>
            </tr>
            <tr>
              <td class="theadReserveA" style="width: 80px;padding: 10px 20px;text-align: left;font-size: 14px;font-weight: 500;color: #666;">1</td>
              <td class="theadReserveA" style="width: 80px;padding: 10px 20px;text-align: left;font-size: 14px;font-weight: 500;color: #666;">仅元素分析</td>
              <td class="theadReserveA" style="width: 80px;padding: 10px 20px;text-align: left;font-size: 14px;font-weight: 500;color: #666;">
                EDS元素分析：
                100元/感兴区域；
                EDS元素分布(Mapping)：
                125元/线扫；
                150元/面扫。
              </td>
              <td class="theadReserveA" style="width: 80px;padding: 10px 20px;text-align: left;font-size: 14px;font-weight: 500;color: #666;">
                EDS元素分析：
                300元/感兴区域；
                EDS元素分布(Mapping)：
                375元/线扫；
                450元/面扫
              </td>
              <td class="theadReserveA" style="width: 80px;padding: 10px 20px;text-align: left;font-size: 14px;font-weight: 500;color: #666;">
                EDS元素分析：300元/样；
                EDS元素分布(Mapping)：
                400元/线扫；
                500元/面扫。
              </td>
              <td class="theadReserveA" style="width: 80px;padding: 10px 20px;text-align: left;font-size: 14px;font-weight: 500;color: #666;">
                每个样品限时半小时，超时后，校内加收100元/半小时、医学院加收价格是校内的1.25倍、校外加收300元/半小时。
              </td>
            </tr>
          </table>
        </td>
      </tr>
    </table> -->

    <div class="optBox">
      <div class="tabs">
        <div class="tab tabActive">送样检测</div>
      </div>
      <div class="dateOpt">
        <div class="opt">
          <div class="datePre" @click="preMonth"><a-icon type="left" /></div>
          <div class="nowdate">{{ globalNow.getFullYear() }}-{{ globalNow.getMonth() + 1 }}</div>
          <div class="dateNext" @click="nextMonth"><a-icon type="right" /></div>
        </div>
      </div>
      <div class="noticeBox">
        <div class="noticeBtn">未开放</div>
        <!-- <div class="noticeBtn btnRed">满员</div> -->
        <div class="noticeBtn btnGreen">已预约</div>
        <div class="noticeBtn btnYellow">未预约</div>
      </div>
      <div class="tableBox" ref="tableBox">
        <div class="weekBox">
          <div class="week">日</div>
          <div class="week">一</div>
          <div class="week">二</div>
          <div class="week">三</div>
          <div class="week">四</div>
          <div class="week">五</div>
          <div class="week">六</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { http } from '@/utils/http'

export default {
  name: 'DayiReserve',
  data() {
    return {
      //获取当前的时间,作为全局变量进行存储使用
      globalNow: new Date(),
    }
  },
  mounted() {
    this.getReserveText()
    this.getReserveRili()
    this.setRILI(this.globalNow)
  },
  methods: {
    // 请求获取预约文本
    getReserveText() {
      http(`/asset-info/getRemind/${this.$route.query.id}`, 'GET').then(res => {
        if (res.success) {
          this.$refs.reserve.innerHTML = res.data.remind ? res.data.remind : '可在后台添加预约文本内容'
        }
      })
    },
    // 请求获取预约日历
    getReserveRili() {
      return new Promise((resolve, reject) => {
        let parameter = {
          assetId: this.$route.query.id,
          date: this.globalNow.getFullYear() + '-' + (this.globalNow.getMonth() + 1)
        }
        http('/reservation/dateNumber', 'POST', parameter).then(res => {
          if (res.success) {
            resolve(res.data)
          } else {
            reject(res.message)
          }
        })
      })
    },
    // 动态生成日历
    async setRILI(params) {
      let data = await this.getReserveRili()
      var arrweeks = ['日','一','二','三','四','五','六'];
      // var div = document.querySelector('.container div');
      var div = this.$refs.tableBox

      setVal.call(this, params)

      function setVal(params){
        var now = new Date(params * 1);//创建一个事件对象
        var table = document.createElement('table');//创建表格
        // var th = table.createTHead();//表格头部的单元格
        // var thRow = th.insertRow()//插入tr
        // var thCell = thRow.insertCell()//插入单元格
        //该属性表示规定单元格可横跨的列数
        // thCell.colSpan = 7;
        // thCell.innerText = now.getFullYear() + '年' + (now.getMonth()+1) + '月';

        var tb = table.createTBody()//创建一个表格的身体
        // var row = tb.insertRow()
        // row.classList.add('thead')//为表头添加样式
        // for(var i = 0;i < 7;i++){
        //   var cell = row.insertCell();//在tr中创建一列
        //   cell.innerText = arrweeks[i];
        // }

        //获取当前月的1号
        var monthStart = new Date(now.setDate(1));
        //然后在获取一号是星期几
        var monthStartWeekDay = monthStart.getDay();
        //定义一个日期计算的时候使用的值
        var dayMonth = new Date(now.setDate(1));
        //设置当月开始之前的月份信息
        var dayBefore = new Date(now.setDate(-monthStartWeekDay));
        
        //创建一个时间对象
        var current = new Date();
        for(var m = 0; m < 6; m++) {
          var dayRow = tb.insertRow()//添加一行
          for(var i = 0; i < 7; i++) {
            var dayCell = dayRow.insertCell();//添加一列
            var cellDiv = document.createElement('div');//td内容器
            var daySpan = document.createElement('span');//容器日期span
            cellDiv.appendChild(daySpan);
            cellDiv.classList.add('day');
            dayCell.appendChild(cellDiv);
            if (dayMonth.getFullYear() == current.getFullYear() && dayMonth.getMonth() == current.getMonth() && dayMonth.getDate() == current.getDate()) {
              dayCell.classList.add('cur');
            }
            if (monthStartWeekDay <= (i + 7 * m)) {
              // dayCell.innerText = dayMonth.getDate();
              // let time = Math.floor(Math.random() * 12)
              // 获取时间戳比较正在处理的时间是否在今天之前，是则过期
              // if (dayMonth.valueOf() < current.valueOf() && dayCell.className.indexOf('cur') == -1) {
              //   dayCell.innerHTML = `<div class="day btnYellow"><div class="time"><img class="timeImg" src="${require('../../assets/images/timeYellow.png')}" />剩余${time}.00小时</div><span>${dayMonth.getDate()}</span></div>`
              // } else if (time == 0) {
              //   dayCell.innerHTML = `<div class="day btnRed"><div class="time"><img class="timeImg" src="${require('../../assets/images/timeRed.png')}" />剩余${time}.00小时</div><span>${dayMonth.getDate()}</span></div>`
              // } else if (time > 0) {
              //   dayCell.innerHTML = `<div class="day btnGreen"><div class="time"><img class="timeImg" src="${require('../../assets/images/timeGreen.png')}" />剩余${time}.00小时</div><span>${dayMonth.getDate()}</span></div>`
              // }
              // 先为当前日默认添加未预约样式
              if (dayMonth.getMonth() == this.globalNow.getMonth()) {
                dayCell.innerHTML = `<div class="day btnYellow"><div class="time"><img class="timeImg" src="${require('../../assets/images/timeYellow.png')}" />预约：0 次</div><span>${dayMonth.getDate()}</span></div>`
              }
              // 循环比对当前是否有预约次数
              data.forEach(item => {
                let nDay = Number(item.date.split('-')[2])
                if (nDay == dayMonth.getDate()) {
                  dayCell.innerHTML = `<div class="day btnGreen"><div class="time"><img class="timeImg" src="${require('../../assets/images/timeGreen.png')}" />预约：${item.number} 次</div><span>${dayMonth.getDate()}</span></div>`
                }
              })

              // 下个月初
              if (dayMonth.getMonth() != monthStart.getMonth()) {
                dayCell.style.color = '#888';
                dayCell.innerHTML = `<div class="day btnGrey"><div class="time"></div><span>${dayMonth.getDate()}</span></div>`
              }
              let dayMonthCopy = JSON.parse(JSON.stringify(dayMonth));
              dayCell.addEventListener('click', () => this.dayClick(dayMonthCopy));

              dayMonth.setDate(dayMonth.getDate() + 1);
            } else { // 上个月末
              dayBefore.setDate(dayBefore.getDate() + 1);
              dayCell.innerText = dayBefore.getDate();
              dayCell.style.color = '#888';
              dayCell.innerHTML = `<div class="day btnGrey"><div class="time"></div><span>${dayBefore.getDate()}</span></div>`
            }

            
          }
        }

        div.appendChild(table);
      }
    },
    // 切换上月
    preMonth() {
      this.$refs.tableBox.innerHTML = ''
      // 每个月开始的时间 设置为1号
      this.globalNow = new Date(this.globalNow.setMonth(this.globalNow.getMonth() - 1, 1))
      this.setRILI(this.globalNow)
    },
    // 切换下月
    nextMonth() {
      this.$refs.tableBox.innerHTML = ''
      // 每个月开始的时间 设置为1号
      this.globalNow = new Date(this.globalNow.setMonth(this.globalNow.getMonth() + 1, 1))
      this.setRILI(this.globalNow)
    },
    // 日历点击事件
    dayClick(time) {
      console.log(time)
    }
  }
}
</script>

<style lang="less" scoped>
.reserveBox {
  min-height: 200px;
}
.optBox {
  width: 100%;
  // height: 520px;
  border: 1px solid #D9D9D9;
  margin-top: 20px;
  padding-bottom: 23px;
  position: relative;
  .tabs {
    width: 100%;
    height: 40px;
    display: flex;
    background: #FAFAFA;
    border-bottom: 1px solid #D9D9D9;
    .tab {
      width: 90px;
      line-height: 40px;
      text-align: center;
      user-select: none;
    }
    .tabActive {
      background-color: #fff;
      border-top: 2px solid #519bcd;
      height: 41px;
    }
  }
  .dateOpt {
    margin-top: 23px;
    display: flex;
    align-items: center;
    justify-content: center;
    user-select: none;
    .opt {
      display: flex;
      align-items: center;
      .datePre, .dateNext {
        width: 24px;
        height: 24px;
        line-height: 24px;
        background: #FAFAFA;
        border-radius: 3px;
        border: 1px solid #D9D9D9;
        color: #979797;
        text-align: center;
        cursor: pointer;
      }
      .datePre {
        margin-right: 12px;
      }
      .dateNext {
        margin-left: 12px;
      }
      .nowdate {
        font-size: 24px;
        font-weight: 600;
        color: #666666;
        line-height: 33px;
      }
    }
  }
  .noticeBox {
    position: absolute;
    top: 66px;
    right: 28px;
    display: flex;
    .noticeBtn {
      width: 60px;
      height: 28px;
      line-height: 28px;
      text-align: center;
      background: #FAFAFA;
      border-radius: 4px;
      color: #999;
      margin-left: 4px;
      user-select: none;
    }
    .btnRed {
      background: #FFDADA;
      color: #DB4545;
    }
    .btnGreen {
      background: #CBEFD9;
      color: #349459;
    }
    .btnYellow {
      background: #FFEBB8;
      color: #C78F00;
    }
  }
  .weekBox {
    // width: 1044px;
    height: 40px;
    background: #FAFAFA;
    border: 1px solid #EEEEEE;
  }
  .tableBox {
    // width: 1044px;
    margin: 16px auto 0;
    .weekBox {
      width: 100%;
      height: 40px;
      background: #FAFAFA;
      border: 1px solid #EEEEEE;
      display: flex;
      .week {
        width: calc(100% / 7);
        line-height: 40px;
        font-size: 14px;
        color: #666;
        padding-left: 16px;
        font-weight: 600;
      }
    }
    /deep/ table {
      width: 100%;
      margin-top: 12px;
      td {
        width: calc(100% / 7);
        .day {
          // width: 142px;
          height: 80px;
          border-radius: 6px;
          padding: 15px 0 0 15px;
          margin-top: 6px;
          .time {
            height: 20px;
            display: flex;
            align-items: center;
            .timeImg {
              width: 20px;
              height: 20px;
              margin-right: 4px;
            }
          }
          span {
            font-size: 24px;
            font-weight: 600;
          }
        }
        .btnGrey {
          background: #FAFAFA;
          color: #999;
        }
        .btnRed {
          background: #FFDADA;
          color: #333;
        }
        .btnGreen {
          background: #CBEFD9;
          color: #333;
        }
        .btnYellow {
          background: #FFEBB8;
          color: #333;
        }
      }
    }
  }
}
.tableReserve {
  border-color: #D9D9D9;
  border-style: none;
  width: 100%;
}
.theadReserve {
  width: 100px;
  text-align: left;
  padding: 15px 16px ;
  font-size: 16px;
  font-weight: 400;
  color: #666;
  background-color: #FAFAFA;
}
.tdReserve {
  padding: 15px 20px;
  text-align: left;
  font-size: 14px;
  font-weight: 400;
  color: #666;
  width: 170px;
  // word-break: break-all;
  // word-wrap: break-word;
}
.tableReserveA {
  border-color: #D9D9D9;
  border-style: none;
  background-color: #FFF;
  margin-top: 15px;
  margin-bottom: 15px;
}
.theadReserveA {
  width: 80px;
  padding: 10px 20px;
  text-align: left;
  font-size: 14px;
  font-weight: 500;
  color: #666;
}
</style>